import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { MaximumPredicateLimit } from '@bingads-webui/filter-commons';
import { seasonalityPredicateValueNameGetter } from '@bingads-webui-campaign/seasonality-id-name-utils';

class PredicateListContainer extends React.PureComponent {
  render() {
    const { PredicateList, getPredicateIconClassName } = this.props;
    return (
      <PredicateList
        entitySchema={this.props.entitySchema}
        i18n={this.props.i18n}
        onEditableFilterUpdate={this.props.onEditableFilterUpdate}
        editableFilter={this.props.editableFilter}
        maximumPredicateLimit={MaximumPredicateLimit}
        popoverContainer={this}
        readOnlyProperties={this.props.readOnlyProperties}
        getPredicateIconClassName={getPredicateIconClassName}
        predicateValueNameGetter={seasonalityPredicateValueNameGetter}
      />
    );
  }
}

PredicateListContainer.propTypes = {
  PredicateList: PropTypes.element.isRequired,
  entitySchema: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onEditableFilterUpdate: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    predicateList: PropTypes.string.isRequired,
  }).isRequired,
  editableFilter: PropTypes.shape({
    query: PropTypes.object,// eslint-disable-line
  }),
  readOnlyProperties: PropTypes.arrayOf(PropTypes.string),
  getPredicateIconClassName: PropTypes.func,
};

PredicateListContainer.defaultProps = {
  editableFilter: null,
  readOnlyProperties: [],
  getPredicateIconClassName: undefined,
};


export class PredicateListBackboneView extends Backbone.View {
  initialize({
    PredicateList,
    entitySchema,
    i18n,
    popoverContainer,
    onEditableFilterUpdate,
    selectableFilter = null,
    editableFilter = null,
    isPoPEnabled = false,
    savedFilters = [],
    recentFilters = [],
    openedPredicateIndex = null,
    selector = [],
    updateWaterfallFilter = null,
    onApplySavedFilter = null,
    onApplyRecentFilter = null,
    maximumPredicateLimit = MaximumPredicateLimit,
    readOnlyProperties = [],
    instrumentation = null,
    hideAddFilterButton = false,
    getPredicateIconClassName = undefined,
  }) {
    this.entitySchema = entitySchema;
    this.i18n = i18n;
    this.onEditableFilterUpdate = onEditableFilterUpdate;
    this.popoverContainer = popoverContainer;
    this.selectableFilter = selectableFilter;
    this.editableFilter = editableFilter;
    this.isPoPEnabled = isPoPEnabled;
    this.savedFilters = savedFilters;
    this.recentFilters = recentFilters;
    this.openedPredicateIndex = openedPredicateIndex;
    this.selector = selector;
    this.updateWaterfallFilter = updateWaterfallFilter;
    this.onApplySavedFilter = onApplySavedFilter;
    this.onApplyRecentFilter = onApplyRecentFilter;
    this.maximumPredicateLimit = maximumPredicateLimit;
    this.readOnlyProperties = readOnlyProperties;
    this.instrumentation = instrumentation;
    this.hideAddFilterButton = hideAddFilterButton;
    this.PredicateList = PredicateList;
    this.getPredicateIconClassName = getPredicateIconClassName;
  }

  render() {
    ReactDOM.render(
      (
        <PredicateListContainer
          PredicateList={this.PredicateList}
          entitySchema={this.entitySchema}
          i18n={this.i18n}
          popoverContainer={this.popoverContainer}
          onEditableFilterUpdate={this.onEditableFilterUpdate}
          editableFilter={this.editableFilter}
          maximumPredicateLimit={MaximumPredicateLimit}
          readOnlyProperties={this.readOnlyProperties}
          getPredicateIconClassName={this.getPredicateIconClassName}
        />
      ), this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
